/*
 * @Author: zsj
 * @Date: 2018-09-20 13:49:22
 * @Last Modified by: zsj
 * @Last Modified time: 2019-01-07 20:03:26
 */

import React, { PureComponent } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
// 包含省市数据
import data from "./data";
import Select from "../Select/";

const _province = data["省份"];
const _params = {
  province: "",
  city: ""
};
export default class AreaLinkage extends PureComponent {
  constructor(props) {
    super(props);
    const { defaultProvince, defaultCity } = props;
    this.state = {
      city: data[defaultProvince] || []
    };
    _params["province"] = defaultProvince || "";
    _params["city"] = defaultCity || "";
  }

  @autobind
  changeProvince(val) {
    const { onSelect } = this.props;
    _params["province"] = val;
    _params["city"] = "";
    this.setState({
      city: data[val]
    });
    onSelect(_params);
  }
  @autobind
  changeCity(val) {
    const { onSelect } = this.props;
    _params["city"] = val;
    onSelect(_params);
  }
  render() {
    const { defaultProvince, defaultCity, className, style } = this.props;
    const { city } = this.state;
    const classes = classNames("area-linkage", className);
    const isCityCorrect =
      Array.isArray(city) &&
      city.length > 0 &&
      city.find(item => {
        return item.value === defaultCity;
      });
    const _defaultCity = isCityCorrect ? defaultCity : "";
    return (
      <div className={classes} style={style}>
        <Select
          options={_province}
          onChange={this.changeProvince}
          clearable={false}
          defaultValue={defaultProvince}
          placeholder="省份"
        />
        <div className="area-linkage-mid" />
        <Select
          options={city}
          onChange={this.changeCity}
          defaultValue={_defaultCity}
          clearable={false}
          placeholder="城市"
        />
      </div>
    );
  }
}
AreaLinkage.displayName = "AreaLinkage";
AreaLinkage.defaultProps = {};
AreaLinkage.propTypes = {
  /** 默认省份 包括北京市，河北省 */
  defaultProvince: PropTypes.string,
  /** 默认城市 包括石家庄市，东城区 */
  defaultCity: PropTypes.string,
  /** 默认callback */
  onSelect: PropTypes.func
};
